import { render, staticRenderFns } from "./CreateContactModal.vue?vue&type=template&id=721ec954&lang=pug"
import script from "./CreateContactModal.vue?vue&type=script&lang=js"
export * from "./CreateContactModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports